import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import axiosInstance from "../../api/axiosInstance";

interface SmtpCampaignReportDawnload {
    id: number,
    receiver_email: string,
    status: number,
    attempt: number,
    smtp_gateway_id: number,
    createdAt: string,
    updatedAt: string,
    smtp_gateway: {
        gateway_name: string,
        from_email: string,
    }
}

interface SmtpCampaignReportState {
    smtpcampaignreportdawnlaoddata: SmtpCampaignReportDawnload[];
    info: { count: number; current_page: number; limit: number; total_page: number } | null;
    error: string | null;
    loading: boolean;
}

interface SmtpCampaignListParams {
    id: number;
    smtp_gateway_name?: string;
    smtp_gatewayemail: string;
    sms_gateway?: number;
    gateway_id?: number;
    gateway_number?: string;
    receiver_email?: string;
    attempt?: number;
    sort_field?: string;
    sort?: 'ASC' | 'DESC';
    status?: number;
    retry_status?: number;
    limit: number;
    page: number;
}


export const GetallSmtpCampaignReportDawnlaod = createAsyncThunk<
    Blob,
    SmtpCampaignListParams,
    { rejectValue: string }
>(
    'GetallSmtpCampaignReportDawnlaod',
    async (params, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(`/api/admin/reports/smtp-campaign/download/${params.id}`, {
                params: {
                    'smtp_gateway.gateway_name': params.smtp_gateway_name,
                    'smtp_gateway.from_email': params.smtp_gatewayemail,
                    receiver_email: params.receiver_email,
                    status: params.status,
                    retry_status: params.retry_status,
                    attempt: params.attempt,
                    sort_field: params.sort_field,
                    sort: params.sort,
                    page: params.page,
                    limit: params.limit
                },
                responseType: 'blob' // Specify that you expect a Blob response
            });
            return response.data; // Return the Blob directly
        } catch (error: any) {
            if (error.response && error.response.data) {
                return rejectWithValue(error.response.data);
            }
            return rejectWithValue(error.message);
        }
    }
);



const initialState: SmtpCampaignReportState = {
    smtpcampaignreportdawnlaoddata: [],
    info: null,
    error: null,
    loading: false,
};

const smtpcampaignreportdawnloadSlice = createSlice({
    name: "smtpcampaignreportdawnlaod",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // ===============get-all-smtp-campaign-reports-dawnlaod-slice-start============
            .addCase(GetallSmtpCampaignReportDawnlaod.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(GetallSmtpCampaignReportDawnlaod.fulfilled, (state, action: PayloadAction<Blob>) => {
                state.loading = false;
            })
            .addCase(GetallSmtpCampaignReportDawnlaod.rejected, (state, action: PayloadAction<string | undefined>) => {
                state.loading = false;
                state.error = action.payload || 'An error occurred';
            });
        // ===============get-all-smtp-campaign-reports-dawnlaod-slice-end============      
    },
});


export default smtpcampaignreportdawnloadSlice.reducer;
